<div *ngIf="readyForProduction" class="status">
  <span class="b2 font-weight-semibold">{{ 'PRODUCTION_ORDER_LITE.VERSION_HISTORY.READY_FOR_PRODUCTION' | bmsTranslate | uppercase }}</span>
</div>
